export function isAnchorLink(href) {
  const anchor = /(^(.+)?\/?(.+\/)?#.*\/?$)/gi;

  return anchor.test(href);
}

export function isEmailAddressLink(href) {
  const emailAddress = /^(mailto:)/i;

  return emailAddress.test(href);
}

export function isJoinrootLink(href) {
  const joinroot = /(^(http(s)?:\/\/)?(.*\.)?joinroot\.com)|(^\/.*\/?$)/gi;

  return joinroot.test(href);
}

export function isPdfLink(href) {
  const pdf = /(\.pdf\/?)$/i;

  return pdf.test(href);
}

export function isPhoneNumberLink(href) {
  const phoneNumber = /^(tel:)/i;

  return phoneNumber.test(href);
}
